// import { getToken } from 'app/helpers/functions/LocalStorageServices';
import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api/v1';
export const SERVER_URL = BASE_URL;
const DEFAULT_TIMEOUT = 10000;

// # Initial Instance

const createRequest = async (method, url, paramsOrData, res, err) => {
  // const token = getToken()
  const config = {
    url,
    method,
    baseURL: BASE_URL,
    // timeout: DEFAULT_TIMEOUT,
    headers: {
      common: {}
    }
  };

  // # If FormData, let browser/axios set boundary, otherwise default to application/json
  if (paramsOrData instanceof FormData) {
    delete config.headers['Content-Type'];
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  // # Validate Method
  if (method === 'GET' || method === 'DELETE') config.params = paramsOrData;
  else config.data = paramsOrData;

  await axios(config)
    .then(async (response) => await res(response))
    .catch((error) => err(error));
};

export const GET_SERVER = async (url, params, res, err) => await createRequest('GET', url, params, res, err);
export const POST_SERVER = (url, data, res, err) => createRequest('POST', url, data, res, err);
export const PUT_SERVER = (url, id, data, res, err) =>
  createRequest('PUT', `${url}/${id}`, data, res, err);
export const DELETE_SERVER = (url, id, res, err) =>
  createRequest('DELETE', `${url}/${id}`, null, res, err);
export const GET_BY_ID_SERVER = (url, id, res, err) =>
  createRequest('GET', `${url}/${id}`, null, res, err);
